let denominaciones = {
  '6': 'Importación',
  '13': 'Exportación',
  '20': 'Traslado',
  '7': 'Nacional',
  '10': 'Internacional',
  '8': 'Carga Suelta',
  '9': 'Container',
  terminales: {
    '1': 'TERMINAL EXOLGAN',
    '2': 'TERMINALES RIO DE LA PLATA (TRP)',
    '3': 'TERMINAL 4 (APM TERMINALS)',
    '4': 'TERMINAL 5 (BACTSSA)',
    '5': 'TERMINAL ZARATE',
    '6': 'PUERTO CAMPANA',
    '7': 'ZONA FRANCA LA PLATA',
    '8': 'PUERTO DE ROSARIO',
    '9': 'PUERTO DE TIGRE',
    '10': 'PUERTO MAR DEL PLATA'
  },
  depositos: {
    '11': 'AMERICAN CARGO',
    '12': 'CAPITAN CORTES',
    '13': 'CARESTIBA S.A.',
    '14': 'CENSER LOGISTICA MUNDIAL',
    '15': 'COAMTRA',
    '16': 'CORVALAN DEPOSITO FISCAL',
    '17': 'DASSA - DEPOSITO AVELLANEDA SUR S.A.',
    '18': 'DEFIBA',
    '19': 'DEFIBA SERVICIOS PORTUARIOS S.A.',
    '20': 'DEFISA',
    '21': 'DEP. FISCAL GARGANO S.A.',
    '22': 'DEPOSITO FISCAL LOPRIMO1',
    '23': 'DEPÓSITO FISCAL PATRÓN',
    '24': 'DEPOSITO GARAY S.A.',
    '25': 'DEPOSITOS ADUANEROS',
    '26': 'DEPOSITOS FISCALES SA',
    '27': 'ENCYM',
    '28': 'FERROPORT S.A.',
    '29': 'GEMEZ BARRACAS',
    '30': 'GEMEZ S.A.',
    '31': 'GEN-POL S.A.',
    '32': 'GRUPO SELSA',
    '33': 'LOGEXPOR',
    '34': 'LOGÍSTICA CENTRAL',
    '35': 'LOINEX SA',
    '36': 'LOTAX',
    '37': 'M.DODERO CIA',
    '38': 'MEGATOM',
    '39': 'MERCOCARGA',
    '40': 'MURCHISON',
    '41': 'PIXEL CO. ( AGROCAMPO)',
    '42': 'PIXEL CO. (ESSO CARD)',
    '43': 'PLATESTIBA S.A.',
    '44': 'S.G.F.ARG. S.A.',
    '45': 'SADECO S.C.A.',
    '46': 'SADIAL SRL',
    '47': 'SAF S.A.',
    '48': 'SAVE CORP. SRL',
    '49': 'SEXTANS S.A.',
    '50': 'SOUTH AMERICAN DOCKS S.A.',
    '51': 'T.C.O.',
    '52': 'TEFASA 1',
    '53': 'TEFASA 2',
    '54': 'TERBASA',
    '55': 'TERMINAL 7',
    '56': 'TERMINAL DE CARGAS ARGENTINA (EZEIZA)',
    '57': 'TERMINAL PANAMERICANA S.A.',
    '58': 'TRANSTERMINAL S.A.',
    '59': 'UNIVERSAL CARGA',
    '60': 'WARRANT COLLATERAL SERVICE',
    '61': 'ZARATE PORT S.A.',
    '62': 'DEPOSITO FISCAL FRIO DOCK',
    '63': 'DEPOSITO FISCAL BAJO CERO',
    '64': 'TERMINAL SUR',
    '65': 'ICB',
    '66': 'DEPOSITO GAMMA MUJICA',
    '67': 'DEPOSITO GAMMA LIBERTADOR',
    '68': 'DEPOSITO ASAS ONE'
  }
}
export default denominaciones



// WEBPACK FOOTER //
// ./src/components/Utils/Denominaciones.js